import { faCircleMinus, faTag } from '@fortawesome/pro-regular-svg-icons';
import { faMinus, faPlus } from '@fortawesome/pro-solid-svg-icons';
import { Box } from 'src/components/Box';
import { Button } from 'src/components/Button';
import { Card } from 'src/components/Card';
import { Chip } from 'src/components/Chip';
import { Icon } from 'src/components/Icon';
import { Stack } from 'src/components/Stack';
import { Typography } from 'src/components/Typography';
import { CartItem } from 'src/models/cart/_types';
import { getPaymentOptionDetails } from 'src/models/cart/utils';


interface PosCartCardProps {
  item: CartItem;
  cartItemIndex: number;
  removeFromCart: (cartItemIndex: number) => void;
  updateQuantity: (cartItemIndex: number, quantity: number) => Promise<void>;
}

export const PosCartCard = ({
  item,
  cartItemIndex,
  removeFromCart,
  updateQuantity,
}: PosCartCardProps) => {
  const shouldShowQuantity = () => {
    return !['group', 'plan', 'workoutplan'].includes(
      item.itemType?.toLowerCase() || ''
    );
  };

  return (
    <Card
      sx={{
        p: 2,
        bgcolor: 'background.paper',
        minHeight: 140,
        width: '100%',
      }}
    >
      <Stack spacing={2} sx={{ height: '100%' }} justifyContent="space-between">
        <Stack>
          <Typography variant="body1">
            {item.name}{' '}
            {item.coupon && (
              <Chip
                label={item.coupon.code}
                icon={
                  <Icon
                    size="small"
                    color="info"
                    icon={faTag}
                  />
                }
              />
            )}
          </Typography>
          <Stack direction="row" spacing={2} alignItems="center">
            <Typography variant="body2" color="text.secondary">
              {getPaymentOptionDetails(item.paymentOption)}
            </Typography>
          </Stack>
        </Stack>

        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent={shouldShowQuantity() ? 'space-between' : 'flex-end'}
        >
          {shouldShowQuantity() && (
            <Stack direction="row" spacing={2} alignItems="center">
              <Box
                onClick={() => updateQuantity(cartItemIndex, item.quantity - 1)}
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{
                  cursor: 'pointer',
                  bgcolor: 'primary.main',
                  borderRadius: 1,
                  width: 24,
                  height: 24,
                  color: 'white',
                }}
              >
                <Icon
                  size="tiny"
                  icon={faMinus}
                />
              </Box>
              <Typography variant="body2">{item.quantity}</Typography>
              <Box
                onClick={() => updateQuantity(cartItemIndex, item.quantity + 1)}
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{
                  cursor: 'pointer',
                  bgcolor: 'primary.main',
                  borderRadius: 1,
                  width: 24,
                  height: 24,
                  color: 'white',
                }}
              >
                <Icon
                  size="tiny"
                  icon={faPlus}
                />
              </Box>
            </Stack>
          )}
          <Button
            sx={{
              alignSelf: 'flex-end',
            }}
            variant="text"
            onClick={() => removeFromCart(cartItemIndex)}
          >
            <Icon
              size="small"
              icon={faCircleMinus}
            />
          </Button>
        </Stack>
      </Stack>
    </Card>
  );
};
